export default __webpack_public_path__ + "media/images/logo-stacked-746d49820b7654c6e9a81d5c203b4b88.svg";